/**
 * @generated SignedSource<<e5d6fb5e26edbc697b135bf048358ba4>>
 * @relayHash 8a1db632d2d2a0d8cfc9880f54625e88
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID m_ih22MtLSoNjPyYgPVGJeiA

import { ConcreteRequest } from 'relay-runtime';
export type AtmosphereRefreshSessionMutation$variables = Record<PropertyKey, never>;
export type AtmosphereRefreshSessionMutation$data = {
  readonly refreshSession: boolean;
};
export type AtmosphereRefreshSessionMutation = {
  response: AtmosphereRefreshSessionMutation$data;
  variables: AtmosphereRefreshSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "refreshSession",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtmosphereRefreshSessionMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtmosphereRefreshSessionMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "m_ih22MtLSoNjPyYgPVGJeiA",
    "metadata": {},
    "name": "AtmosphereRefreshSessionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0c665121b15d92c060f9a84bd1478c70";

export default node;
